<template>
    <div class="row">
        <div class="col-md-12">
            <div class="card-box m-0">
                <form role="form" @submit.prevent="doFilter(1)">
                    <div class="form-group clearfix">
                        <div class="input-group">
                            <input type="text" v-model="filter.search" class="form-control input_search" :placeholder="$t('_deals.filter_main_field_placeholder')">
                            <span class="input-group-btn">
                                <span class="btn btn_green" @click.prevent="doFilter(1)" v-pml-tooltip="$t('filter')">
                                    <i class="fa fa-fw fa-search"></i>
                                </span>
                            </span>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xs-12 col-sm-12 col-md-6 m-b-15">
                            <label>{{ $t('entry_date') }}</label>
                            <div class="input-daterange input-group">
                                <pml-date-picker v-model="filter.created_at_from"></pml-date-picker>
                                <span class="input-group-addon b-0"><i class="fa fa-calendar"></i></span>
                                <pml-date-picker v-model="filter.created_at_to"></pml-date-picker>
                            </div>
                        </div>
                        <div class="col-xs-12 col-sm-12 col-md-6 m-b-15">
                            <label>{{ $t('last_change_date') }}</label>
                            <div class="input-daterange input-group" id="date-range2">
                                <pml-date-picker v-model="filter.updated_at_from"></pml-date-picker>
                                <span class="input-group-addon b-0"><i class="fa fa-calendar"></i></span>
                                <pml-date-picker v-model="filter.updated_at_to"></pml-date-picker>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xs-12 col-sm-6 col-md-6 col-lg-3 m-b-15">
                            <label>{{ $t('team') }}</label>
                            <pml-select v-model="filter.team_id" :options="teams"></pml-select>
                        </div>
                        <div class="col-xs-12 col-sm-6 col-md-6 col-lg-3 m-b-15">
                            <label>{{ $t('consultant') }}</label>
                            <pml-select-members v-model="filter.member_id" :allow-empty="true" :onlyActive="true"></pml-select-members>
                        </div>
                        <div class="col-xs-12 col-sm-6 col-md-6 col-lg-3 m-b-15">
                            <label>{{ $t('followed_by') }}</label>
                            <pml-select-members v-model="filter.follower_id" :allow-empty="true" :all="true" :only-follow="true" :onlyActive="true"></pml-select-members>
                        </div>
                        <div class="col-xs-12 col-sm-6 col-md-6 col-lg-3 m-b-15">
                            <label>{{ $t('status') }}</label>
                            <pml-multiselect v-model="filter.status_s" :options="status"></pml-multiselect>
                        </div>
                        <div class="col-xs-12 col-sm-6 col-md-6 col-lg-3 m-b-15">
                            <label>{{ $t('perception') }}</label>
                            <pml-multiselect v-model="filter.perceptions" :options="perceptions"></pml-multiselect>
                        </div>
                        <div class="col-xs-12 col-sm-6 col-md-6 col-lg-3 m-b-15">
                            <label>{{ $t('source') }}</label>
                            <pml-multiselect v-model="filter.sources" :options="sources"></pml-multiselect>
                        </div>
                        <div class="col-xs-12 col-sm-6 col-md-6 col-lg-3 m-b-15">
                            <label>{{ $t('segment') }}</label>
                            <pml-multiselect v-model="filter.segments" :options="segments"></pml-multiselect>
                        </div>
                        <div class="col-xs-12 col-sm-6 col-md-6 col-lg-3 m-b-15">
                            <label>{{ $t('pipeline') }}</label>
                            <pml-select-group v-model="filter.pipeline_step_id" :options="pipelines" group-values="steps" group-label="name" class="select_pipeline"></pml-select-group>
                        </div>
                    </div>
                    <strong class="m-t-5 m-l-10">
                        {{ $t('available_this_month') }}: {{ tenant.max_massive - tenant.massive_count }}
                    </strong>
                    <hr class="m-t-0">
                    <div class="clearfix text-center">
                        <span class="btn btn-white pull-left" @click.prevent="clear()"><i class="fa fa-paint-brush m-r-5"></i> {{ $t('clear') }}</span>

                        <button class="btn btn-default" @click="goToSentEmailsCreate" :disabled="selecteds.length == 0" v-if="(tenant.max_massive - tenant.massive_count != 0)">
                            <span class="btn-label">
                                <i class="fa fa-plus-circle"></i>
                            </span>
                            {{ $t('email') }}
                        </button>
                        <button class="btn btn-default" @click="goToSentEmailsCreate" disabled v-pml-tooltip="$t('massive_count_exceeded')" v-else>
                            <span class="btn-label">
                                <i class="fa fa-plus-circle"></i>
                            </span>
                            {{ $t('email') }}
                        </button>
                        <button class="btn btn_green pull-right" type="submit">
                            <span class="btn-label">
                                <i class="fa fa-search"></i>
                            </span>
                            {{ $t('filter') }}
                        </button>

                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
    import bus from 'utils/events/bus'
    import Notify from 'utils/helpers/notify'
    import { trans } from 'utils/helpers/translation'
    import { getAllPaged } from 'services/deals'
    import { mapGetters } from 'vuex'

    export default {
        name: 'EmailsFilter',
        data () {
            return {
                page: 1,
                pagination: {
                    from: 0,
                    to: 0,
                    total: 0
                },
                filter: {
                    amount: 200,
                    created_at_from: '',
                    created_at_to: '',
                    updated_at_from: '',
                    updated_at_to: '',
                    orderBy: 'updated_at',
                    orderDirection: 'desc',
                    team_id: '',
                    follower_id: '',
                    member_id: '',
                    perception: '',
                    source_id: '',
                    pipeline_step_id: '',
                    status_s: ['open']
                },
                selecteds: []
            }
        },
        computed: {
            ...mapGetters({
                'perceptions': 'getDealPerceptions',
                'segments': 'getSegments',
                'sources': 'getSources',
                'members': 'getMembers',
                'member': 'getMember',
                'pipelines': 'getPipelines',
                'status': 'getDealStatus',
                'teams': 'getTeams',
                'tenant': 'getTenant'
            })
        },
        created () {
            bus.$on('doFilterDeals', this.doFilter)
            bus.$on('addSelected', this.addSelected)
            bus.$on('removeSelected', this.removeSelected)
            bus.$on('selectedAll', this.handleSelectedAll)
        },
        destroyed () {
            bus.$off('doFilterDeals')
            bus.$off('addSelected', this.addSelected)
            bus.$off('removeSelected', this.removeSelected)
            bus.$off('selectedAll', this.handleSelectedAll)
        },
        methods: {
            clear () {
                this.filter = {
                    created_at_from: '',
                    created_at_to: '',
                    source_id: null,
                    segment_id: null,
                    orderBy: 'created_at',
                    orderDirection: 'desc',
                    status_s: []
                }
                this.doFilter(1)
            },
            doFilter (page = null) {
                bus.$emit('listLoadingDeals', true)

                this.page = page === null ? this.page : page

                getAllPaged(this.page, this.filter)
                    .then(response => {
                        this.pagination = response.data
                        bus.$emit('paginationRefreshDeals', response.data)
                    })
                    .catch(() => Notify.error(trans('_notifications.error')))
                    .then(() => bus.$emit('listLoadingDeals', false))
            },
            orderRefresh (obj) {
                this.filter.orderBy = obj.orderProp
                this.filter.orderDirection = obj.orderDir
                this.doFilter(1)
            },
            addSelected (ids) {
                this.selecteds = [...new Set(this.selecteds.concat(ids))]
            },
            removeSelected (ids) {
                this.selecteds = this.selecteds.filter(item => !ids.includes(item))
            },
            handleSelectedAll (val) {
                bus.$emit('selectedAllItems', val)
            },
            goToSentEmailsCreate () {
                this.$router.push({ name: 'massive-emails.create', query: { ids: JSON.stringify(this.selecteds) } })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/emails/massive/components/Filter.vue